export default __webpack_public_path__ + "static/media/Auditorium.56ae83fa.png";